import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface ModelViewersKeyType {
  singular: LocalesKey;
  disableNeutralMaterials: LocalesKey;
  enableNeutralMaterials: LocalesKey;
  showHelpers: LocalesKey;
  hideHelpers: LocalesKey;
  meshEdgesNone: LocalesKey;
  meshEdgesEdges: LocalesKey;
  meshEdgesWireframe: LocalesKey;
  screenshot: LocalesKey;
  threeDModelViewer: LocalesKey;
  addReference: LocalesKey;
  removeReference: LocalesKey;
  createLifestyle: LocalesKey;
  createSilo: LocalesKey;
  createCloseUp: LocalesKey;
  lifestyleSceneDescription: LocalesKey;
  siloSceneDescription: LocalesKey;
  closeUpSceneDescription: LocalesKey;
  generationModeLabel: LocalesKey;
  generationModeLifestyle: LocalesKey;
  generationModeSilo: LocalesKey;
  generationModeSiloRender: LocalesKey;
  generationModeCloseUp: LocalesKey;
  generationModeEdit: LocalesKey;
  generatingLifestyle: LocalesKey;
  createdLifestyles: LocalesKey;
  generationFailed: LocalesKey;
  generatedLifestyle: LocalesKey;
  lifestylePromptPlaceholder: LocalesKey;
  backToModel: LocalesKey;
  backgroundDefault: LocalesKey;
  backgroundBlack: LocalesKey;
  backgroundWhite: LocalesKey;
  backgroundGray: LocalesKey;
  backgroundCustom: LocalesKey;
  backgroundImage: LocalesKey;
  backgroundColorPicker: LocalesKey;
  backgroundImageModalTitle: LocalesKey;
  aiImageryTool: LocalesKey;
  openConfigurator: LocalesKey;
  configuratorExportFailed: LocalesKey;
  commands: LocalesKey;
  removeCommand: LocalesKey;
  quickLifestyle: LocalesKey;
  displaySettings: LocalesKey;
  aspectRatio: LocalesKey;
  aspectRatioAuto: LocalesKey;
  aspectRatioSquare: LocalesKey;
  aspectRatioLandscape: LocalesKey;
  aspectRatioPortrait: LocalesKey;
  aspectRatioShowGridLines: LocalesKey;
  resolution: LocalesKey;
  unitsMetric: LocalesKey;
  unitsImperial: LocalesKey;
  meshDisplay: LocalesKey;
  meshDisplayNormal: LocalesKey;
  toolHand: LocalesKey;
  toolMeasure: LocalesKey;
  requestRender: LocalesKey;
  studioRender: LocalesKey;
  renderingImage: LocalesKey;
  renderingImageDescription1: LocalesKey;
  renderingImageDescription2: LocalesKey;
  renderingImageDescription3: LocalesKey;
  renderRequested: LocalesKey;
  renderRequestFailed: LocalesKey;
  generationModeProductLifestyle: LocalesKey;
  createProductLifestyle: LocalesKey;
  createProductLifestyleShort: LocalesKey;
  closeWithoutSavingTitle: LocalesKey;
  closeWithoutSavingDescription: LocalesKey;
  closeAnyway: LocalesKey;
}

export const modelViewersKeys = keyPathMirror<ModelViewersKeyType, string>(
  {
    singular: null,
    disableNeutralMaterials: null,
    enableNeutralMaterials: null,
    showHelpers: null,
    hideHelpers: null,
    meshEdgesNone: null,
    meshEdgesEdges: null,
    meshEdgesWireframe: null,
    screenshot: null,
    threeDModelViewer: null,
    addReference: null,
    removeReference: null,
    createLifestyle: null,
    createSilo: null,
    createCloseUp: null,
    lifestyleSceneDescription: null,
    siloSceneDescription: null,
    closeUpSceneDescription: null,
    generationModeLabel: null,
    generationModeLifestyle: null,
    generationModeSilo: null,
    generationModeSiloRender: null,
    generationModeCloseUp: null,
    generationModeEdit: null,
    generatingLifestyle: null,
    createdLifestyles: null,
    generationFailed: null,
    generatedLifestyle: null,
    lifestylePromptPlaceholder: null,
    backToModel: null,
    backgroundDefault: null,
    backgroundBlack: null,
    backgroundWhite: null,
    backgroundGray: null,
    backgroundCustom: null,
    backgroundImage: null,
    backgroundColorPicker: null,
    backgroundImageModalTitle: null,
    aiImageryTool: null,
    openConfigurator: null,
    configuratorExportFailed: null,
    commands: null,
    removeCommand: null,
    quickLifestyle: null,
    displaySettings: null,
    aspectRatio: null,
    aspectRatioAuto: null,
    aspectRatioSquare: null,
    aspectRatioLandscape: null,
    aspectRatioPortrait: null,
    aspectRatioShowGridLines: null,
    resolution: null,
    unitsMetric: null,
    unitsImperial: null,
    meshDisplay: null,
    meshDisplayNormal: null,
    toolHand: null,
    toolMeasure: null,
    requestRender: null,
    studioRender: null,
    renderingImage: null,
    renderingImageDescription1: null,
    renderingImageDescription2: null,
    renderingImageDescription3: null,
    renderRequested: null,
    renderRequestFailed: null,
    generationModeProductLifestyle: null,
    createProductLifestyle: null,
    createProductLifestyleShort: null,
    closeWithoutSavingTitle: null,
    closeWithoutSavingDescription: null,
    closeAnyway: null
  },
  'models.modelViewers.'
);
